import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { hotTags } from "@/mocks/homeStats";

export default function TagSection() {
  const [activeTag, setActiveTag] = useState("海角黑料证据");

  return (
    <section id="tags" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-center">
          <Reveal className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-secondary-700">
              KEYWORDS
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常被搜索的关键词
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              下面这些是访客用得最多的检索词。先选一个词，再回到上面的类型入口或实锤汇总里定位，会比直接翻列表更快。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              当前选中：
              <span className="ml-1 rounded-md bg-primary-100 px-2 py-0.5 font-medium text-primary-700">
                {activeTag}
              </span>
            </p>
          </Reveal>

          <Reveal className="lg:col-span-8" delay={80}>
            <div className="flex flex-wrap gap-2.5">
              {hotTags.map((tag) => {
                const active = activeTag === tag.name;
                return (
                  <button
                    key={tag.id}
                    type="button"
                    onClick={() => setActiveTag(tag.name)}
                    className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-3.5 py-2 text-sm transition-colors ${
                      active
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                    }`}
                  >
                    {tag.name}
                    <span
                      className={`text-xs ${
                        active ? "text-background-100" : "text-foreground-400"
                      }`}
                    >
                      {tag.count}
                    </span>
                  </button>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}